import { Component, OnInit, ViewChild } from '@angular/core';
import { HistoricoEventoService } from '../../../../../services/database/historico-evento.service';
import { TranslateService } from '@ngx-translate/core';
import { CustomTableComponent, CustomTitle, DataColumnType, ICustomTable } from 'lib-base';
import { firstValueFrom, forkJoin } from 'rxjs';
import { DialogModule } from 'primeng/dialog';
import { ISecPermisoHistorico } from '../../../../../shared/interfaces/database/seguridad';

@Component({
  selector: 'app-permisos-historico',
  standalone: true,
  imports: [CustomTableComponent, DialogModule, CustomTitle],
  templateUrl: './permisos-historico.component.html',
  styleUrl: './permisos-historico.component.scss'
})
export class PermisosHistoricoComponent implements OnInit {

  title: string = 'Permiso Historial';
  displayModal: boolean = false;
  trans: any = {};
  customTable !: ICustomTable;
  @ViewChild(CustomTableComponent) customTableComponent !: CustomTableComponent;

  constructor(private _hes: HistoricoEventoService, private _t: TranslateService) { }

  ngOnInit(): void {
    this.translate();
  }

  private async translate(): Promise<void> {
    this.trans = await firstValueFrom(forkJoin({
      codificacion: this._t.get('common.codificacion'),
      descripcion: this._t.get('common.descripcion'),
      tipo: this._t.get('common.tipo'),
      usuarioEvento: this._t.get('common.usuarioEvento'),
      evento: this._t.get('common.evento'),
      fechaActualizacion: this._t.get('common.fechaActualizacion'),
    }));
    this.configColumns();
  }

  private configColumns() {
    this.customTable = {
      columns: [
        {
          field: 'codificacion',
          header: this.trans.codificacion,
          sort: true,
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'descripcion',
          header: this.trans.descripcion,
          sort: true,
          columnFilter: false,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'tipo',
          header: this.trans.tipo,
          sort: true,
          columnFilter: true,
          dataType: DataColumnType.TEXT
        },
        {
          field: 'usuarioEvento',
          header: this.trans.usuarioEvento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'evento',
          header: this.trans.evento,
          width: '5rem',
          dataType: DataColumnType.TEXT
        },
        {
          field: 'fechaActualizacion',
          header: this.trans.fechaActualizacion,
          width: '5rem',
          dataType: DataColumnType.DATE
        },
      ]
    } as ICustomTable;

  }

  show(hojaDeVidaTramiteId: number) {
    this.displayModal = true;
    this.loadHistorial(hojaDeVidaTramiteId);
  }

  showEliminado() {
    this.displayModal = true;
    this.loadHistorialEliminado();
  }

  hide() {
    this.displayModal = false;
  }

  loadHistorial(secPermisoId: number) {
    this._hes.getSecPermisoHistorico(secPermisoId).subscribe({
      next: (data: ISecPermisoHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }

  loadHistorialEliminado() {
    this._hes.getSecPermisoHistoricoEliminado().subscribe({
      next: (data: ISecPermisoHistorico[]) => {
        this.customTableComponent.data = data;
      }
    });
  }
}

